import { useAceTable } from '@/app/common/components/Table/useAceTable'
import { useValidatedParams } from '@/app/common/hooks'
import { ProviderIdParams } from '@/app/pages/providers/schema'
import { ProviderQueries } from '@/queries/providers/queries'
import { selectSelectedProgram } from '@/storage/programs/slice'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import AssociatedStudentsTable from './_components/associated-students-table'

export default function AssociatedStudentsPage() {
  const programId = useSelector(selectSelectedProgram).id
  const { providerId } = useValidatedParams(ProviderIdParams)

  return (
    <AssociatedStudentsContent
      key={`${providerId}-${programId}`}
      providerId={providerId}
      programId={programId}
    />
  )
}

type AssociatedStudentsContentProps = {
  providerId: string
  programId: number
}

function AssociatedStudentsContent({
  providerId,
  programId,
}: AssociatedStudentsContentProps) {
  const table = useAceTable()

  const associatedStudentsQuery = useQuery(
    ProviderQueries.getAssociatedStudents({
      providerId,
      programId,
      currentPage: table.currentPage,
      recordsPerPage: table.recordsPerPage,
      search: table.debouncedSearch.trim() || undefined,
    })
  )

  return (
    <div className="p-4 max-w-7xl mx-auto w-full">
      <AssociatedStudentsTable
        students={associatedStudentsQuery.data?.data ?? []}
        currentPage={table.currentPage}
        recordsPerPage={table.recordsPerPage}
        totalRows={associatedStudentsQuery.data?.total ?? 0}
        search={table.search}
        status={associatedStudentsQuery.status}
        errorMessage={
          associatedStudentsQuery.error?.message ??
          'Unable to load associated students.'
        }
        onSearchChange={table.onSearchChange}
        onPageChange={table.onPageChange}
        onPerPageChange={table.onPerPageChange}
        onRefresh={() => {
          void associatedStudentsQuery.refetch()
        }}
      />
    </div>
  )
}
